import React, { useEffect, useState } from "react";
import { getHierarchyData } from "../Db_Connections/hierarchyApi";
import "../Assests/HierarchyPage.css";

// ─────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────

// Name ko proper format me dikhane ke liye
const formatName = (name = "") =>
  name
    .toLowerCase()
    .split(" ")
    .map((word) =>
      word ? word.charAt(0).toUpperCase() + word.slice(1) : ""
    )
    .join(" ");

// Name compare karne ke liye clean format
const normalize = (text = "") =>
  text.toLowerCase().replace(/\s+/g, " ").trim();

// ─────────────────────────────────────────────
// Single Node Component
// ─────────────────────────────────────────────
const OrgTreeNode = ({ node }) => {
  const children = node.children || [];
  const hasChildren = children.length > 0;
  const isSingleChild = children.length === 1;

  return (
    <div className="node-wrapper">
      {/* Employee Card */}
      <div className="node-card">
        <div className="avatar">
          {node.name ? node.name[0].toUpperCase() : "?"}
        </div>

        <h4 title={node.name}>{formatName(node.name)}</h4>      
        <p className="role">{formatName(node.designation)}</p>

        {/* node.role && <span className="badge">{node.role}</span> */}
        {/* {node.department && <p className="dept">{node.department}</p>} */}
      </div>

      {/* Children */}
      {hasChildren && (
        <div className="children-wrapper">
          <div className="vertical-line"></div>

          <div className={`children ${isSingleChild ? "single-child-row" : ""}`}>
            {children.map((child) => (
              <div key={child.id} className="child">
                <div
                  className={`child-line ${
                    isSingleChild ? "single-child-line" : ""
                  }`}
                ></div>

                <OrgTreeNode node={child} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────
// Build Tree from Flat Employee Data
// ─────────────────────────────────────────────
const buildTree = (employees = []) => {
  const employeeMap = {};
  const employeeNameMap = {};

  // Step 1: Har employee ka node banao
  employees.forEach((emp) => {
    const fullName = `${emp.first_name || ""} ${emp.last_name || ""}`.trim();

    employeeMap[emp.id] = {
      id: emp.id,
      name: fullName,
      designation: emp.designation,
      role: emp.role,
      department: emp.department,
      manager_name: emp.manager_name,
      children: [],
    };

    employeeNameMap[normalize(fullName)] = emp.id;
  });

  // Step 2: Root node
  const root = {
    id: "root",
    name: "Genkaix",
    // designation: "Root",
    role: "",
    department: "",
    children: [],
  };

  // Step 3: Admin identify karo
  let adminNode = null;

  employees.forEach((emp) => {
    if (emp.role?.toLowerCase().includes("admin")) {
      adminNode = employeeMap[emp.id];
    }
  });

  // Step 4: Parent-child relation banao
  employees.forEach((emp) => {
    const currentNode = employeeMap[emp.id];
    const managerName = normalize(emp.manager_name || "");

    // Admin ko kisi ke niche nahi dalna
    if (currentNode === adminNode) return;

    // Agar manager mil gaya to uske niche add karo
    if (managerName && employeeNameMap[managerName]) {
      const managerId = employeeNameMap[managerName];
      employeeMap[managerId].children.push(currentNode);
    }
    // Agar manager nahi mila but admin hai to admin ke niche dalo
    else if (adminNode) {
      adminNode.children.push(currentNode);
    }
    // Warna root ke niche
    else {
      root.children.push(currentNode);
    }
  });

  // Step 5: Admin ko root ke niche dalo
  if (adminNode) {
    root.children.push(adminNode);
  }

  return root;
};

// ─────────────────────────────────────────────
// Main Page Component
// ─────────────────────────────────────────────
export default function HierarchyPage() {
  const [tree, setTree] = useState(null);

  useEffect(() => {
    const loadHierarchy = async () => {
      const data = await getHierarchyData();
      const hierarchyTree = buildTree(data);
      setTree(hierarchyTree);
    };

    loadHierarchy();
  }, []);

  return (
    <div className="hierarchy-page">
      <div className="tree-outer-card">
        <h2 className="org-heading">Organisation Chart</h2>

        <div className="tree-scroll-area">
          {tree && <OrgTreeNode node={tree} />}
        </div>
      </div>
    </div>
  );
}